import FormStyles from './FormStyles';

export default FormStyles;
